function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgTgIcon = function SvgTgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18282_116286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6869 24.619C19.3138 24.5359 24.6185 19.0963 24.5354 12.4694C24.4522 5.84252 19.0127 0.537766 12.3858 0.62092C5.75888 0.704074 0.454129 6.14364 0.537283 12.7705C0.620437 19.3974 6.06001 24.7022 12.6869 24.619Z",
    fill: "url(#paint0_linear_18282_116286)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.96782 12.5757C9.44666 11.0078 11.7666 9.97382 12.9276 9.47374C16.2425 8.04593 16.9318 7.79648 17.3831 7.78286C17.4823 7.77987 17.7045 7.80168 17.8498 7.91653C17.9724 8.01351 18.0075 8.14615 18.0246 8.23934C18.0418 8.33253 18.0643 8.54502 18.0506 8.71145C17.8938 10.611 17.1703 15.2252 16.7994 17.3552C16.6425 18.2565 16.3151 18.5622 15.9948 18.5957C15.2988 18.6685 14.7631 18.1506 14.0827 17.7166C13.0179 17.0376 12.4159 16.6142 11.3823 15.9515C10.1878 15.1857 10.9504 14.747 11.6168 14.0373C11.7912 13.8515 14.8263 11.0205 14.8825 10.7664C14.8896 10.7346 14.895 10.6164 14.824 10.5549C14.7531 10.4935 14.6498 10.5161 14.5753 10.534C14.4697 10.5594 12.7966 11.6956 9.556 13.9428C9.08125 14.2776 8.64951 14.4433 8.26078 14.4398C7.83224 14.4359 7.00519 14.2133 6.39004 14.0218C5.63553 13.787 5.03668 13.6653 5.08348 13.2498C5.10786 13.0334 5.40264 12.8087 5.96782 12.5757Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18282_116286",
    x1: 12.3858,
    y1: 0.62092,
    x2: 12.6847,
    y2: 24.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18282_116286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.386719 0.771484) rotate(-0.718911)"
  }))));
};
export default SvgTgIcon;